module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA10.42490761.jpg";